let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lP9Ot")).then(() => parcelRequire('i1BaA'));